/** Texto de pregunta según idioma (fallback a ES). */
export function preguntaTexto(pregunta, language) {
  if (!pregunta) return "";
  const lng = String(language || "es").slice(0, 2).toLowerCase();
  if (lng === "en" && pregunta.texto_en) return pregunta.texto_en;
  return pregunta.texto_es || pregunta.texto_en || "";
}
